import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that implements the Array.reverse() method.
 */
@Pipe({
  name: 'rdsReverseArray',
})
export class RdsReverseArrayPipe implements PipeTransform {
  transform(array: any[]): any[] {
    if (!array || !array.length) {
      return [];
    }
    return array.slice().reverse();
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [RdsReverseArrayPipe],
  declarations: [RdsReverseArrayPipe],
})
export class RdsReverseArrayPipeModule {}
